import type { ITooltipParams } from 'ag-grid-community';
import * as R from 'ramda';

import { checkIsTooltipActive } from './helpers';

import Styles from './TooltopComponent.module.css';

export const AgGridCellTooltipValueGetter =
    ({ fieldName }: { fieldName?: string }) =>
    <T = any,>(params: ITooltipParams<T>) => {
        const { data, value, valueFormatted } = params;

        if (!data) {
            return null;
        }

        if (fieldName && data[fieldName as keyof T]) {
            return data[fieldName as keyof T];
        }

        if (fieldName && Array.isArray(fieldName)) {
            return R.path(R.split('.', fieldName), data);
        }

        if (value || valueFormatted) {
            return valueFormatted ?? value;
        }

        return '';
    };

export const AgGridCellTooltipComponent = <T,>(params: ITooltipParams<T>) => {
    const { column, value, valueFormatted, colDef } = params;

    const checkboxSelection = !!(colDef && 'checkboxSelection' in colDef);

    const cellValue = valueFormatted ?? value;

    if (typeof cellValue === 'object') {
        return '';
    }

    const actualCellWidth = (column?.getActualWidth() ?? 0) - (checkboxSelection ? 38 : 0);

    const tooltipContent = (
        <div className={checkboxSelection ? `${Styles.tooltip} ${Styles.checkboxSelection}` : Styles.tooltip}>
            {cellValue}
        </div>
    );

    return checkIsTooltipActive(cellValue, actualCellWidth) ? tooltipContent : '';
};

AgGridCellTooltipComponent.displayName = 'AgGridCellTooltipComponent';
